export const getFileNameFromUrl = (url?: string | null) => {
  if (!url) return '';
  try {
    const sanitized = url.split('?')[0]?.split('#')[0] || '';
    const parts = sanitized.split('/');
    const name = parts[parts.length - 1] || '';
    return decodeURIComponent(name);
  } catch {
    return '';
  }
};
